module.exports = __webpack_public_path__ + "img/sso_register_response.786fe656.png";